import { render, staticRenderFns } from "./RecruitingReport.vue?vue&type=template&id=4a71a3da&scoped=true&"
import script from "./RecruitingReport.vue?vue&type=script&lang=js&"
export * from "./RecruitingReport.vue?vue&type=script&lang=js&"
import style0 from "./RecruitingReport.vue?vue&type=style&index=0&id=4a71a3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71a3da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
